import React, {useState} from 'react';
import {Link} from 'react-router-dom'
import "./footer.css";
import axios from '../helper/axios'
import WhatsupChat from './Common/WhatsupChat';
import AssistantHint from './Common/AssistantHint';
import Cookies from './Common/Cookies';
import facebook from '../assets/icons/icons-01.png';
import insta from '../assets/icons/icons-02.png';
import youtube from '../assets/icons/icons-03.png';
import linkedIn from '../assets/icons/icons-04.png';
import website from '../assets/icons/Contact-01.png';
import phone from '../assets/icons/Contact-02.png';

import icons05 from '../assets/icons/icons-05.png';
import icons06 from '../assets/icons/icons-06.png';
import icons07 from '../assets/icons/icons-07.png';
import icons08 from '../assets/icons/icons-08.png';


export default function Footer() {
const [accordion, setAccordion] = useState({'help':false,'order':false,'address':false,'contact':false})
    return (
        <>
            <WhatsupChat/>
            <AssistantHint/>
            <footer className="bg-white border-t text-gray-700 ">
                <div className="footer_section max-w-8xl mx-auto px-12 py-10  container mx-auto">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-8 justify-items-left footer-wrapper">

                        <div className="text-left">
                            <h3 className={"text-lg font-semibold text-gray-900 capitalize mb-4 footer-accordion" + (accordion.help ? ' active' : '')} onClick={()=>setAccordion(prevState => ({...prevState,help:!prevState.help}))}>Ndihma &
                                Informacioni <i className='gg-chevron-down'/> </h3>
                            <ul className="space-y-2 text-sm">
                                <li><Link to="/terms-conditions" className="font-medium hover:text-blue-600 transition">Kushtet
                                    e blerjes</Link></li>
                                <li><Link to="/privacy" className="font-medium hover:text-blue-600 transition">Kushtet e
                                    privatësisë</Link></li>
                                {/* <li><a href="https://www.youtube.com/watch?v=ILgpsTxa7TU" target="_blank" rel="noreferrer" className="font-medium hover:text-blue-600 transition">Si të blej online</a></li>
                <li><Link to="/our-partners" className="font-medium hover:text-blue-600 transition">Partnerët tanë</Link></li> */}
                            </ul>
                        </div>

                        <div className="text-left">
                            <h3 className={"text-lg font-semibold text-gray-900  mb-4 footer-accordion" + (accordion.order ? ' active' : '')} onClick={()=>setAccordion(prevState => ({...prevState,order:!prevState.order}))}>Porosia ime <i className='gg-chevron-down'/></h3>
                            <ul className="space-y-2 text-sm">
                                <li><Link to="/delivery"
                                          className="font-medium hover:text-blue-600 transition">Transporti</Link></li>
                                <li><Link to="/returns" className="font-medium hover:text-blue-600 transition">Politikat
                                    e kthimit</Link></li>
                                <li><Link to="/faq" className="font-medium hover:text-blue-600 transition">Pyetjet e
                                    shpeshta</Link></li>
                            </ul>
                        </div>

                        <div className="text-left">
                            <h3 className={"text-lg font-semibold text-gray-900 capitalize mb-4 footer-accordion" + (accordion.address ? ' active' : '')} onClick={()=>setAccordion(prevState => ({...prevState,address:!prevState.address}))}>
                                <span className={'hidden sm:block'}>Adresa</span>
                                <span className={'sm:hidden'}>Kontakti & Adresa</span>
                                <i className='gg-chevron-down'/></h3>
                            <ul className="space-y-2 text-sm">
                                <li className="font-medium sm:hidden">
                                    <a className='flex gap-2' href="https://www.linkedin.com/company/albi-online/"
                                       target="_blank">
                                        <img src={website} style={{height: "18px"}}/>
                                        info@albionline.com
                                    </a>
                                </li>

                                <li className="font-medium sm:hidden">
                                    <a className='flex gap-2' href="https://www.linkedin.com/company/albi-online/"
                                       target="_blank">
                                        <img src={phone} style={{height: "18px"}}/>
                                        +383 48 300 800
                                    </a>
                                </li>
                                <li className="font-medium">Zona e Re Industriale</li>
                                <li className="font-medium">Veternik, 10000, Prishtinë</li>
                                <li className="font-medium">Kosovë</li>
                            </ul>
                        </div>

                        <div className="text-left hidden sm:block">
                            <h3 className="text-lg font-semibold text-gray-900  mb-4">Na ndiqni</h3>
                            <ul className="space-y-2 text-sm">
                                <li className="font-medium">
                                    <a className='flex gap-2' href={"https://www.facebook.com/albimallonline"}
                                       target="_blank">
                                        <img src={facebook} style={{height: "18px"}}/>
                                        Facebook
                                    </a></li>
                                <li className="font-medium">

                                    <a className='flex gap-2' href="https://www.instagram.com/albionline/"
                                       target="_blank">
                                        <img src={insta} style={{height: "18px"}}/>
                                        Instagram
                                    </a>
                                </li>
                                <li className="font-medium">
                                    <a className='flex gap-2'
                                       href="https://www.tiktok.com/@albionline.com"
                                       target="_blank">
                                        <img src={youtube} style={{height: "18px"}}/>
                                        TikTok
                                    </a></li>


                            </ul>
                        </div>


                        <div className="text-left sm:block hidden">
                            <h3 className={"text-lg font-semibold text-gray-900 capitalize mb-4 footer-accordion" + (accordion.contact ? ' active' : '')} onClick={()=>setAccordion(prevState => ({...prevState,contact:!prevState.contact}))}>Kontakti <i className='gg-chevron-down'/></h3>
                            <ul className="space-y-2 text-sm">
                                <li className="font-medium">
                                    <a className='flex gap-2' href="https://www.linkedin.com/company/albi-online/"
                                       target="_blank">
                                        <img src={website} style={{height: "18px"}}/>
                                        info@albionline.com
                                    </a>
                                </li>

                                <li className="font-medium">
                                    <a className='flex gap-2' href="https://www.linkedin.com/company/albi-online/"
                                       target="_blank">
                                        <img src={phone} style={{height: "18px"}}/>
                                        +383 48 300 800
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <ul className="w-full sm:hidden flex flex-row justify-center gap-5 text-sm text-gray-900 mb-4 footer-accordion">
                            <li className="font-medium">
                                <a className='flex gap-2' href={"https://www.facebook.com/albimallonline"}
                                   target="_blank">
                                    <img src={facebook} style={{height: "30px"}}/>
                                </a></li>
                            <li className="font-medium">

                                <a className='flex gap-2' href="https://www.instagram.com/albionline/"
                                   target="_blank">
                                    <img src={insta} style={{height: "30px"}}/>
                                </a>
                            </li>
                            <li className="font-medium">
                                <a className='flex gap-2'
                                   href="https://www.tiktok.com/@albionline.com"
                                   target="_blank">
                                    <img src={youtube} style={{height: "30px"}}/>
                                </a></li>


                        </ul>
                    </div>
                </div>

                {/* <div className="pb-5 px-12 flex mx-auto  payments"> */}

                    {/* <div style={{flex: 1}}/> */}
                    {/* <div className="right_section_payment flex justify-center space-x-2" style={{marginRight: "4%"}}> */}
                        {/* <img
                            className="h-8 w-13"
                            src={icons05}
                            alt="Visa"
                        />
                        <img
                            className="h-8 w-13"
                            src={icons06}
                            alt="VisaElectron"
                        />
                        <img
                            className="h-8 w-13"
                            src={icons07}
                            alt="VisaElectron"
                        /> */}
                        {/* <img
                            className="h-8 w-13"
                            src={icons08}
                            alt="VisaElectron"
                        /> */}

                    {/* </div> */}

                {/* </div> */}

                <div className="bg-gray-100">
                    <div className="max-w-6xl mx-auto px-4 py-4 border-t text-center text-sm text-gray-600">
                        <span
                            className="font-medium"> All authorized rights © Albi Online {new Date().getFullYear()}</span>
                    </div>
                </div>
            </footer>


            <Cookies/>
        </>

    )
}
